import { render, staticRenderFns } from "./BannerTabLinks.vue?vue&type=template&id=7c0e0032"
import script from "./BannerTabLinks.vue?vue&type=script&lang=js"
export * from "./BannerTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports